import ThirdParties from "./ThirdParties.container";

export default ThirdParties;
